// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateTagsResult = objectOf({
  template_ids: arrayOf(string),
  current_template_tags_state: arrayOf(
    objectOf({
      id: string,
      tags: arrayOf(string),
    })
  ),
});
